const removeInpAlerts = () => {

    const allWpcfInpts = document.querySelectorAll('.wpcf7 input');

    if(allWpcfInpts){
        const responseInp = document.querySelector('.wpcf7-response-output');

        allWpcfInpts.forEach(inp => {
            inp.addEventListener('click', () =>{
                inp.classList.remove('wpcf7-not-valid');
                responseInp.style.display = 'none';
            }, false);
        });
    }
}

module.exports = removeInpAlerts;